module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('g', {
    class: _vm.data,
    attrs: {
      "id": "boy3"
    }
  }, [_c('path', {
    attrs: {
      "id": "boy3_bag_3",
      "fill": "#91713D",
      "d": "M6006.55 305h-13.1c-8.53 0-15.45 6.8-15.45 15.2v27.6c0 8.4 6.92 15.2 15.45 15.2h13.1c8.53 0 15.45-6.8 15.45-15.2v-27.6c0-8.4-6.92-15.2-15.45-15.2z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy3_left_hand",
      "fill": "#BC9555",
      "d": "M6039 366.13c.22 1.56 1.18 2.38 2.57 4.08 1.64 2 1.95 5.85 3.87 8.9-.34.8-3.13-.28-3.82-1.52-.7-1.24-1.23-2.25-1.45-2.56-.23-.3-.68-.23-.78.1-.1.33.94 11.7.72 12.3-.22.58-1.8.8-2.16.25-.34-.54-1.42-9.5-1.6-9.73-.15-.23-.5-.07-.62.07-.13.16 1.32 9.7 1.12 10.1-.2.37-1.84.5-2.06.24-.2-.28-1.47-9.82-1.67-10-.2-.2-.57-.14-.7.07-.12.22 1.44 9.37 1.23 9.8-.2.42-1.8.62-2 .24-.2-.4-1.68-9.6-1.85-9.7-.16-.13-.37-.1-.5.05-.13.13.58 7.06.37 7.46-.2.4-1.4.64-1.64.2s-1.8-17.84-1.94-18.77c-.47-3.1.2-6.56 5.3-7.17 5.1-.62 7.17 2.26 7.6 5.6z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy3_left_arm_bottom",
      "fill": "#BC9555",
      "d": "M6029.88 345.2c-3.6.43-6.14 3.64-5.7 7.17l1.94 15.53c.44 3.53 3.7 6.04 7.3 5.6 3.58-.43 6.13-3.64 5.7-7.17l-1.95-15.53c-.44-3.53-3.7-6.04-7.3-5.6z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy3_left_arm_top",
      "fill": "#BC9555",
      "d": "M6025.5 309.78c-3.58.43-6.13 3.64-5.7 7.17l4.45 35.62c.44 3.53 3.7 6.04 7.3 5.6 3.58-.43 6.13-3.64 5.7-7.17l-4.46-35.62c-.45-3.53-3.7-6.04-7.3-5.6z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy3_left_sleeve",
      "fill": "#FBD79E",
      "d": "M6025.57 309.65c-4.52.55-7.8 4.5-7.46 8.97l1.38 17.72 18.55-2.24-3.02-17.53c-.76-4.42-4.9-7.46-9.43-6.92z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "boy3_left_sock",
      "width": "14",
      "height": "17",
      "x": "6015",
      "y": "420",
      "fill": "#91713D"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy3_left_shoe_5",
      "fill": "#FBD79E",
      "d": "M6041.9 440.94c-2.22-.52-7.52-3.9-11.76-6.88-2.82.84-12.28.9-15.05 0-1.3-.4-2.43-.88-2.73.65-.2 1.04.7 1.7 2.72 1.96v12.03h33.63c.42-4-1.85-6.6-6.82-7.76z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy3_left_shoe_4",
      "fill": "#A98448",
      "d": "M6042.28 440.4c-2.23-.53-11.3-6.27-11.78-6.9-.47-.6-.6-2.96-1.03-7.3-.8-1-4.97-1.3-5.65.3-.7 1.6.38 4.64 2.1 7.62 1.72 2.98 9 6.85 11.82 7.85 2.83 1 6.17-.3 4.54-1.58z"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "boy3_left_shoe_3",
      "fill": "#91713D",
      "points": "6032.89347 435.448474 6029.73489 438.988967 6027.73022 437.453411 6030.91692 434.113553"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "boy3_left_shoe_2",
      "fill": "#91713D",
      "points": "6038.03391 438.668503 6034.87533 442.208996 6032.87066 440.67344 6036.05736 437.333581"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "boy3_left_shoe_1",
      "cx": "6018",
      "cy": "442",
      "r": "3",
      "fill": "#A98448"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy3_left_leg_bottom",
      "fill": "#BC9555",
      "d": "M6022 392c3.87 0 7 3.08 7 6.9V420h-14v-21.1c0-3.82 3.13-6.9 7-6.9z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy3_left_leg_top",
      "fill": "#91713D",
      "d": "M6020.62 353c-5.87 0-10.62 4.7-10.62 10.5V404h23l-1.4-40.52c-.2-5.85-5.06-10.48-10.98-10.48z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "boy3_right_sock",
      "width": "14",
      "height": "17",
      "x": "5990",
      "y": "420",
      "fill": "#91713D"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy3_right_shoe_5",
      "fill": "#FBD79E",
      "d": "M6017.15 440.94c-2.23-.52-7.54-3.9-11.78-6.88-2.82.84-12.28.9-15.05 0-1.3-.4-2.42-.88-2.72.65-.2 1.04.7 1.7 2.72 1.96v12.03h33.65c.4-4-1.86-6.6-6.82-7.76z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy3_right_shoe_4",
      "fill": "#A98448",
      "d": "M6017.5 440.4c1.64 1.26-1.7 2.58-4.53 1.57-2.83-1-10.1-4.87-11.82-7.85-1.72-2.98-2.8-6.03-2.1-7.63.68-1.6 4.84-1.3 5.66-.3.43 4.34.56 6.7 1.03 7.3.47.63 9.55 6.37 11.78 6.9z"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "boy3_right_shoe_3",
      "fill": "#91713D",
      "points": "6008.12591 435.448474 6004.96732 438.988967 6002.96265 437.453411 6006.14935 434.113553"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "boy3_right_shoe_2",
      "fill": "#91713D",
      "points": "6013.26634 438.668503 6011.28979 437.333581 6008.10309 440.67344 6010.10776 442.208996"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "boy3_right_shoe_1",
      "cx": "5998",
      "cy": "442",
      "r": "3",
      "fill": "#A98448"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy3_right_leg_bottom",
      "fill": "#BC9555",
      "d": "M5997 392c3.87 0 7 3.08 7 6.9V420h-14v-21.1c0-3.82 3.13-6.9 7-6.9z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy3_right_leg_top",
      "fill": "#91713D",
      "d": "M5998.38 353c-5.92 0-10.77 4.63-10.97 10.48L5986 404h23v-40.5c0-5.8-4.75-10.5-10.62-10.5z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy3_hip",
      "fill": "#91713D",
      "d": "M6031.5 353.15h-43.83v15.18c0 3.3 2.72 5.98 6.07 5.98h31.68c3.35 0 6.07-2.66 6.07-5.97v-15.18z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy3_torso",
      "fill": "#FBD79E",
      "d": "M6027.7 312.53c-3.47-9.2-31.42-8.8-34.4 0-2.97 8.8-6.7 50.2-6.07 51.16 5.56 8.58 41.18 5.62 45.28 1.27 1.76-1.86-2.92-47.5-4.8-52.44z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy3_bag_2",
      "fill": "#A98448",
      "d": "M6000.26 307.6c8.8 5.25 8.65 37.44-5.38 41.46-.12-2.04 0-36.5 0-38.4.3-1.4 3.8-3.05 5.38-3.05z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy3_bag_1",
      "fill": "#A98448",
      "d": "M6028.58 314.2c-.74-2.48-3.35-5.37-5.58-5.67 2.88 10.42 6.3 23.94 8.5 33.5-.44-8-1.92-24.48-2.92-27.83z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy3_right_hand",
      "fill": "#BC9555",
      "d": "M5997.75 367c0 1.55.86 2.5 2.03 4.34 1.38 2.16 1.22 6.03 2.74 9.3-.44.75-3.07-.66-3.6-1.98-.54-1.3-.94-2.38-1.13-2.7-.2-.35-.65-.32-.8 0-.14.3-.5 11.72-.8 12.28-.28.56-1.88.58-2.16 0-.28-.58-.24-9.6-.38-9.85-.13-.25-.48-.14-.63 0-.15.1.1 9.76-.14 10.12-.25.36-1.9.3-2.08 0-.18-.3-.24-9.9-.42-10.13-.18-.23-.55-.2-.7 0-.15.18.26 9.45 0 9.84-.26.4-1.87.4-2 0-.16-.4-.5-9.72-.65-9.85-.15-.15-.36-.14-.5 0-.16.1-.3 7.07-.57 7.45-.26.37-1.47.46-1.65 0-.18-.47.42-17.92.4-18.86-.08-3.15 1-6.5 6.15-6.5 5.14 0 6.84 3.12 6.87 6.5z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy3_right_arm_bottom",
      "fill": "#BC9555",
      "d": "M5991.3 345.33c-3.6 0-6.54 2.9-6.54 6.44v15.64c0 3.57 2.93 6.45 6.54 6.45 3.62 0 6.55-2.88 6.55-6.44v-15.63c0-3.55-2.93-6.44-6.55-6.44z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy3_right_arm_top",
      "fill": "#BC9555",
      "d": "M5991.5 309c-3.6 0-6.5 2.9-6.5 6.47v36.06c0 3.57 2.9 6.47 6.5 6.47s6.5-2.9 6.5-6.47v-36.06c0-3.57-2.9-6.47-6.5-6.47z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy3_right_sleeve",
      "fill": "#FBD79E",
      "d": "M5991.5 309c-4.63 0-8.44 3.56-8.65 8.08L5982 335h19l-.85-17.92c-.2-4.52-4.02-8.08-8.65-8.08z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy3_neck",
      "fill": "#BC9555",
      "d": "M6016.44 303.07c-.38 2.42-.53 3.4.56 4.72-.27.5-1.63 4.06-4.85 4.06-3.22 0-6.27-2.92-6.83-4.07.98-1.38 1.16-2.03.58-4.73.73-1.95 9.53-1.88 10.54 0z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy3_face",
      "fill": "#BC9555",
      "fill-rule": "nonzero",
      "d": "M5994.15 286.8c-1-.58-2.42-1.3-4.04 0-1.37 1.1-.33 5.5 1.54 7.92 1.85 2.4 4.85 2.9 6.03 1.98 2.16 5.44 10.86 8.12 16.5 7.98 10.1-.25 17.06-9.96 16.4-20.06-.94-14.78-8.6-21.63-18.7-21.63-9.03-.06-20.2 6.17-17.72 23.8z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy3_mouth_bottom",
      "fill": "#A98448",
      "d": "M6016.88 300.25h-7.25c-.75 0 1.94 1.4 4.36 1.4 2.4 0 3.55-1.4 2.88-1.4z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy3_mouth_top",
      "fill": "#A98448",
      "d": "M6018.23 299.82h-9.06c-.94 0 2.43-1.87 5.45-1.87s4.45 1.87 3.6 1.87z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy3_nose",
      "fill": "#A98448",
      "d": "M6015.85 285.9c0-1.06-2.8-1.15-2.8 0 0 1.17-.9 7.25 0 8.33.9 1.07 3.54.7 3.95 0 .4-.72-1.15-7.25-1.15-8.32z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy3_left_eye_whites",
      "fill": "#FBD79E",
      "d": "M6018.84 286.73c1.3-3.02 7.16-3.48 8.04-.87 0 3.53-7.1 3.84-8.04.87z"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "id": "boy3_left_pupil",
      "cx": "6023.6",
      "cy": "286.05",
      "fill": "#91713D",
      "rx": "2.01",
      "ry": "1.98"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy3_right_eye_whites",
      "fill": "#FBD79E",
      "d": "M6010.06 286.73c-1.32-3.02-7.17-3.48-8.05-.87 0 3.53 7.1 3.84 8.06.87z"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "id": "boy3_right_pupil",
      "cx": "6007.25",
      "cy": "286.05",
      "fill": "#91713D",
      "rx": "2.01",
      "ry": "1.98"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy3_left_brow",
      "fill": "#91713D",
      "d": "M6019.02 283.05c.24-1.36 7.82-1.38 7.97-.17.14 1.22-1.45.64-3.54.87-2.1.23-4.68.66-4.44-.7z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy3_right_brow",
      "fill": "#91713D",
      "d": "M6009.98 283.05c-.24-1.36-7.82-1.38-7.97-.17-.14 1.22 1.45.64 3.54.87 2.1.23 4.68.66 4.44-.7z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy3_hair",
      "fill": "#91713D",
      "d": "M6015 273.52c-10.15-8.1-13.13 9.42-17.6 17.37-.5-.9-.78-2.22-.88-3.97-.98 2.26-2.12 3.77-3.42 4.54v-5c-.57 1.6-2.23 3.22-4.53 4.42.93-2.34.86-5.83.86-8.35 0-2.53 1.84-27.86 24.62-20.53 21.68-1.35 16.26 23.92 17.97 29.45-5.1-3.95-4.94-26.04-17.03-17.95z"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9e1ca750","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/module_2/backgroundCharacters/boyThree.vue
// module id = 659
// module chunks = 1